import { render, staticRenderFns } from "./LanSettings.vue?vue&type=template&id=bd18a8d8&scoped=true&"
import script from "./LanSettings.vue?vue&type=script&lang=js&"
export * from "./LanSettings.vue?vue&type=script&lang=js&"
import style0 from "./LanSettings.vue?vue&type=style&index=0&id=bd18a8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd18a8d8",
  null
  
)

export default component.exports